export const UrlConfigPublic = {
  login: "login",
  register: "register",
  RecoverPassword: "recoverPassword",
};
